import React, { useState } from "react";
import PropTypes from "prop-types";
import logger from "../logger/logger";
import { capex_lifespans } from "../data/inputData"
import { PrimaryButtonStyled, SecondaryButtonStyled, SimpleButtonStyled } from "../styles/Button";
import { ErrorMessageStyled, FormNavContainerStyled, InputStyled } from "../styles/Form";
import { TableStyled, TableHeaderStyled, TableDataStyled, TableRowStyled } from '../styles/Table';
import { PageHeader2Styled, PageHeaderSubTextMobileStyled, PageHeaderSubTextStyled } from "../styles/Main";
import InputDescriptions from "./InputDescriptions";

const CapExInputsForm = ({ handleIncrementFormStep, handleDecrementFormStep, formData, setFormData, errors, isMobile }) => {
  const [showInputDescriptions, setShowInputDescriptions] = useState(false);

  const handleChange = (field, value) => {
    let formPrimaryZip = {...formData[Object.keys(formData)[0]] }
    formPrimaryZip[field] = { ...formPrimaryZip[field], "value": value }
    let newFormData = { ...formData };
    newFormData[Object.keys(formData)[0]] = formPrimaryZip
    setFormData(newFormData);
    logger.debug(`Form field updated: ${field} with value ${value}`);    
  };

  const showInputs = () => {
    const formPrimaryZip = {...formData[Object.keys(formData)[0]]}
    const ageInputs = Object.fromEntries(
    Object.entries(formPrimaryZip).filter(([key, value]) => (value.type === 'capex_age') )
  )
    const costInputs = Object.fromEntries(
      Object.entries(formPrimaryZip).filter(([key, value]) => (value.type === 'capex_cost') )
    )
    return Object.keys(ageInputs).map((item) => (
      <TableRowStyled key={item}>
        <TableDataStyled $size={30}>
          {ageInputs[item].displayName.replace('Age', '').replace('/', ' / ')}
        </TableDataStyled>
        <TableDataStyled $size={30}>
          <InputStyled
            type="number"
            pattern="[0-9]*"
            placeholder={isMobile?'Age':`Enter ${ageInputs[item].displayName}`}
            value={formPrimaryZip[item].value || ""}
            onChange={(e) => handleChange(item, e.target.value)}
            aria-label={`Input for ${ageInputs[item].displayName}`}
          />
        </TableDataStyled>
        <TableDataStyled $size={40}>
          <InputStyled
            type="number"
            pattern="[0-9]*"
            step="0.01"
            min="0"
            placeholder={isMobile?"Cost":"Replacement Cost"}
            value={formPrimaryZip[item.replace('_age', '_replacement_cost')].value || ""}
            onChange={(e) => handleChange(item.replace('_age', '_replacement_cost'), e.target.value)}
            aria-label={`Replacement Cost for ${costInputs[item.replace('_age', '_replacement_cost')].displayName}`}
          />
        </TableDataStyled>
        {!isMobile?<TableDataStyled>{capex_lifespans[item.replace('_age', '')]}</TableDataStyled>:<></>}
      </TableRowStyled>
    ))
  }

  return (
    <div>
      {
        showInputDescriptions?
        <InputDescriptions inputs={capex_lifespans} type={'capex'} setShowInputDescriptions={setShowInputDescriptions}/>:
        <div>
          <PageHeader2Styled>Capital Expenditures</PageHeader2Styled>   
          <>  
            {
              isMobile?
              <>
                <PageHeaderSubTextMobileStyled>Please enter the values for capex numbers including costs and lifespans of items</PageHeaderSubTextMobileStyled>
                <SimpleButtonStyled onClick={() => setShowInputDescriptions(1)}>Show Input Details</SimpleButtonStyled>
              </>:   
              <PageHeaderSubTextStyled>Please enter the values for capex numbers including costs and lifespans of items</PageHeaderSubTextStyled>
              
            }
              
          </>
          <TableStyled>
            <thead>
              <TableRowStyled>
                <TableHeaderStyled $size={30}>Property Details</TableHeaderStyled>
                <TableHeaderStyled $size={30}>Current Age</TableHeaderStyled>
                <TableHeaderStyled $size={40}>{isMobile?'Cost to Replace':'Replacement Cost'}</TableHeaderStyled>
                {!isMobile?<TableHeaderStyled>Average Life (Years)</TableHeaderStyled>:<></>}
              </TableRowStyled>
            </thead>
            <tbody>
              {showInputs()}
            </tbody>
          </TableStyled>
          <div>
            {errors.length > 0 ? 
                <div>
                  {errors.map(((error, i) => (
                    <ErrorMessageStyled key={i}>{error.message}</ErrorMessageStyled>
                  )))}
                </div>:
                <></>
            }
          </div>
          <FormNavContainerStyled>
            <SecondaryButtonStyled onClick={handleDecrementFormStep}>Back</SecondaryButtonStyled>
            <PrimaryButtonStyled onClick={handleIncrementFormStep}>Next</PrimaryButtonStyled>
          </FormNavContainerStyled>
        </div>
      }
    </div>
  );
};

CapExInputsForm.propTypes = {
  handleIncrementFormStep: PropTypes.func.isRequired, 
  handleDecrementFormStep: PropTypes.func.isRequired, 
  formData: PropTypes.object.isRequired, 
  setFormData: PropTypes.func.isRequired
};

export default CapExInputsForm;